import { j as s } from "../../_virtual/jsx-runtime.js";
import { c } from "../../_virtual/compiler-runtime.js";
import { useState as p } from "react";
import { PortalRootContext as d } from "./portal-root-context.js";
const j = (i) => {
  const t = c.c(6), {
    children: l
  } = i, [m, n] = p(document.body);
  let o;
  t[0] !== l || t[1] !== m ? (o = /* @__PURE__ */ s.jsx(d, { value: m, children: l }), t[0] = l, t[1] = m, t[2] = o) : o = t[2];
  let e;
  t[3] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ s.jsx("div", { "data-surge-portal-root": !0, ref: (a) => {
    n(a ?? document.body);
  } }), t[3] = e) : e = t[3];
  let r;
  return t[4] !== o ? (r = /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    o,
    e
  ] }), t[4] = o, t[5] = r) : r = t[5], r;
};
export {
  j as PortalRootProvider
};
